;(function () {
  angular
    .module('contrast.org.vulnerabilities')
    .factory('traceRenderService', traceRenderServiceFactory)

  function traceRenderServiceFactory(
    $q,
    traceApiConfig,
    appTracesApiConfig,
    traceCommonRenderService,
    ErrorService,
    ServiceUtils
  ) {
    'ngInject'

    return {
      getTraceStory: getTraceStory,
      getRecommendation: getRecommendation,
      getEvents: getEvents,
      getHttpRequest: getHttpRequest,
      getTraceServer: getTraceServer,
      getTraceRequirements: getTraceRequirements,
      getTrace: getTrace,
      loadNotes: loadNotes,
      addNote: addNote,
      editNote: editNote,
      getTraceRoutes: getTraceRoutes,
      getVulnerabilityInstanceMetadata: getVulnerabilityInstanceMetadata,
      getVulnerabilityInstancesDetails: getVulnerabilityInstancesDetails
    }

    function getTraceStory(scope, uuid) {
      appTracesApiConfig
        .getTraceStory(uuid)
        .then(function (response) {
          traceCommonRenderService.getTraceStory(
            scope,
            response.data.story,
            response.data.custom_risk
          )
        })
        .catch(ErrorService.processError)
    }

    function getRecommendation(scope, uuid) {
      appTracesApiConfig
        .getTraceRecommendation(uuid)
        .then(function (response) {
          traceCommonRenderService.getRecommendation(scope, response.data)
        })
        .catch(ErrorService.processError)
    }

    function getEvents(uuid, useLegacyStrategies) {
      return appTracesApiConfig
        .getEventsSummary(uuid, { legacy: useLegacyStrategies })
        .then(ServiceUtils.handleResolve('data'))
        .catch(ServiceUtils.handleError)
    }

    function getHttpRequest(scope, uuid) {
      appTracesApiConfig
        .getHttpRequest(uuid)
        .then(function (response) {
          traceCommonRenderService.getHttpRequest(scope, response.data)
        })
        .catch(ErrorService.processError)
    }

    function getTraceServer(scope, appId, uuid) {
      traceApiConfig
        .getTraceServers(appId, uuid, '')
        .then(function (response) {
          traceCommonRenderService.getTraceServer(scope, response.data.servers)
        })
        .catch(ErrorService.processError)
    }

    function getTraceRequirements(scope, appId, uuid) {
      traceApiConfig
        .getTraceRequirements(appId, uuid, '')
        .then(function (response) {
          traceCommonRenderService.getTraceRequirements(
            scope,
            response.data.requirements
          )
        })
        .catch(ErrorService.processError)
    }

    function getTrace(scope, appId, uuid) {
      traceApiConfig
        .getTrace(appId, uuid, 'application')
        .then(function (response) {
          traceCommonRenderService.getTrace(scope, response.data.trace)
        })
        .catch(ErrorService.processError)
    }

    function loadNotes(scope, appId, uuid) {
      return appTracesApiConfig
        .getNotes(appId, uuid)
        .then(function (response) {
          traceCommonRenderService.loadNotes(scope, response.data.notes)
        })
        .catch(ErrorService.processError)
    }

    function addNote(scope, appId, uuid) {
      return appTracesApiConfig
        .addNote(appId, uuid, scope.model.note)
        .then(
          function () {
            this.scope.model.note = ''
          }.bind({ scope: scope })
        )
        .catch(ErrorService.processError)
    }

    function editNote(appId, uuid, note, data) {
      if (data.length !== 0 && note.unsafe !== data) {
        return appTracesApiConfig
          .editNote(appId, uuid, note.id, data)
          .catch(ErrorService.processError)
      }
      return $q.when(data)
    }

    function getTraceRoutes(scope, appId, uuid) {
      traceApiConfig
        .getTraceRoutes(appId, uuid)
        .then(function (response) {
          traceCommonRenderService.getTraceRoutes(scope, response.data.routes)
        })
        .catch(ErrorService.processError)
    }

    function getVulnerabilityInstanceMetadata(scope, appId, uuid) {
      traceApiConfig
        .getVulnerabilityInstanceMetadata(appId, uuid)
        .then(function (response) {
          traceCommonRenderService.getVulnerabilityInstanceMetadata(
            scope,
            response.data.session
          )
        })
        .catch(ErrorService.processError)
    }

    function getVulnerabilityInstancesDetails(scope, appId, uuid) {
      appTracesApiConfig
        .getVulnerabilityInstancesDetails(appId, uuid)
        .then(function (response) {
          traceCommonRenderService.getVulnerabilityInstancesDetails(
            scope,
            response.data.instances
          )
        })
        .catch(ErrorService.processError)
    }
  }
})()
